import { Box, Button, CircularProgress, Container, Paper, Stack, Typography } from '@mui/material'
import CloudOffOutlinedIcon from '@mui/icons-material/CloudOffOutlined'

interface Props {
  aoTentarNovamente: () => void
  tentando: boolean
}

export function SemConexaoPage({ aoTentarNovamente, tentando }: Props): JSX.Element {
  return (
    <Container maxWidth="sm" sx={{ pt: 8 }}>
      <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ mb: 2 }}>
          <CloudOffOutlinedIcon sx={{ fontSize: 64, color: 'text.disabled' }} />
        </Box>

        <Typography variant="h5" gutterBottom>
          Sem conexão com o servidor
        </Typography>

        <Typography color="text.secondary">
          Não conseguimos falar com o servidor agora. Verifique a internet do local — vamos continuar
          tentando sozinhos.
        </Typography>

        <Stack spacing={1.5} alignItems="center" sx={{ mt: 3 }}>
          <Button
            variant="outlined"
            fullWidth
            size="large"
            disabled={tentando}
            onClick={aoTentarNovamente}
            startIcon={tentando ? <CircularProgress size={20} /> : undefined}
            sx={{ textTransform: 'none' }}
          >
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              {tentando ? 'Tentando...' : 'Tentar agora'}
            </Typography>
          </Button>
        </Stack>
      </Paper>
    </Container>
  )
}
